import { WebLink } from "../../../stores/active-survey-store/weblink-types";

export type LinkStatus = "active" | "inactive" | "expired" | "at-capacity";

export function getLinkStatus(link: WebLink): LinkStatus {
  if (!link.active) return "inactive";
  if (link.srids_count >= link.maxlimit) return "at-capacity";

  const now = new Date();
  if (link.active_until && new Date(link.active_until) < now) return "expired";
  if (link.active_from && new Date(link.active_from) > now) return "inactive";

  return "active";
}

export function formatDate(dateString: string | null): string {
  if (!dateString) return "-";
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return dateString;
  }
}

